import React, {Component} from 'react';
import App from "../../App";
import {Link, withRouter} from "react-router-dom";
import {MdArrowBack} from "react-icons/all";
import {Alert} from "react-bootstrap";

class Details extends Component {
  state = {}

  render() {
    const {entrepreneurDetails} = this.state;

    return (
      <App layout={`boxed`}>
        <div className="main-content">
          <div className="page-header">
            <div className="page-title"/>
            <div className="ml-auto">
              <Link to={`${process.env.PUBLIC_URL}/staff/list`} className={`btn btn-sm btn-link`}><MdArrowBack/> Back
                to List</Link>
            </div>
          </div>

          <div className="card-block">
            <div className="block-header">
              <h4 className="block-title">Staff Details</h4>
            </div>
            <div className="block-body">
              <>
                <table className="info-table">
                  <tbody>
                  <tr>
                    <td style={{width: '250px'}}>Name</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td className={`text-bold`}>Rahim</td>
                  </tr>
                  <tr>
                    <td style={{width: '250px'}}>Bangla</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td>রহিম</td>
                  </tr>
                  <tr>
                    <td style={{width: '250px'}}>Email</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td>rahim@gmail.com</td>
                  </tr>
                  <tr>
                    <td style={{width: '250px'}}>Phone</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td>+8801775663322</td>
                  </tr>
                  <tr>
                    <td style={{width: '250px'}}>Address</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td>Dhaka, Bangladesh</td>
                  </tr>
                  <tr>
                    <td style={{width: '250px'}}>Role</td>
                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                    <td>Product Manager</td>
                  </tr>
                  </tbody>
                </table>
              </>
            </div>
          </div>
        </div>
      </App>
    );
  }
}

export default withRouter(Details);